import { isValidImage, isValidLatitude, isValidLongitude, MaterialIcon } from '@gorila-shared-ui/components';
import { Overflow } from 'baseui/icon';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useCamera } from '../../../hooks/useCamera';
import { useStyles } from '../../../hooks/useStyles';
import { EvidenceMedia } from '../../../types/evidences';

type Props = {
  media: EvidenceMedia;
};

function EvidenceMediaMarker({ media }: Readonly<Props>) {
  const { zoomTo } = useCamera();
  const { css, theme } = useStyles();
  const iconWrapper = css({
    display: 'inline-block',
    lineHeight: 0,
    background: theme.colors.backgroundInversePrimary,
    borderRadius: '50%',
    padding: theme.sizing.scale200,
  });

  if (!media.latitude || !isValidLatitude(media.latitude) || !media.longitude || !isValidLongitude(media.longitude)) {
    return null;
  }

  const { latitude, longitude } = media;

  const onClick = () => {
    zoomTo({
      lat: latitude,
      lng: longitude,
    });
  };

  return (
    <Marker
      longitude={longitude}
      latitude={latitude}
      rotation={0}
      onClick={onClick}
    >
      <span className={iconWrapper}>
        {media.key && (
          <MaterialIcon
            name={isValidImage(media.key) ? 'image' : 'videocam'}
            size={'18px'}
            color={theme.colors.contentInversePrimary}
          />
        )}
        {!media.key && (
          <Overflow
            size="18px"
            color={theme.colors.contentInversePrimary}
            aria-label="no media"
            title="Pendiente"
          />
        )}
      </span>
    </Marker>
  );
}

export default memo(EvidenceMediaMarker);
